import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Navbar from './Navbar';

const DashboardLayout = () => {
  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <Sidebar />

      <div style={{ flex: 1, background: '#ecf0f1', overflowY: 'auto' }}>
        <Navbar />
        <div style={{ padding: 0 }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
